<template>
  <message-dialog
    :dialog="true"
    :ok-button-loading="settingPreferences"
    persistent
    @cancel="setPreferencesAndClose({ global_opt_in_asked_modal: true })"
    @ok="setPreferencesAndClose({ global_opt_in_asked_modal: true, global_opt_in: true })"
  >
    <template #title>{{ $translate("common.canWeStayInTouch") }}</template>
    <template #content>{{ $translate("common.wedLoveToKeepYouUpdated") }}</template>
    <template #cancel>{{ $translate("common.notNow") }}</template>
    <template #ok>{{ $translate("common.optIn") }}</template>
  </message-dialog>
</template>

<script>
import { mapActions } from "pinia"

import { useUserSessionStore } from "@/store/userSession.js"

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settingPreferences: false
    }
  },
  methods: {
    ...mapActions(useUserSessionStore, ["setMarketingPreferences"]),
    setPreferencesAndClose(preferences) {
      this.settingPreferences = true
      try {
        this.setMarketingPreferences(preferences)
      } finally {
        this.settingPreferences = false
        this.$emit("close")
      }
    }
  }
}
</script>
